export default class MForm
{
	constructor(el) {
		this.el = el;
	}

	getMethod()
	{
		return this.el.method;
	}

	getUrl()
	{
		return this.el.action;
	}

	getData()
	{
		let data = {};
		let formData = new FormData(this.el);

		for (let pair of formData.entries()) {
			data[pair[0]] = pair[1];
		}

		return data;
	}

	getErrorsElement()
	{
		return this.el.querySelector('.b-errors');
	}

	resetErrors()
	{
		this.el.querySelectorAll('.b-errors').forEach(el => {
			el.innerHTML = '';
			el.setAttribute('hidden', '');
		});

		this.el.querySelectorAll('.has-error').forEach(el => {
			el.classList.remove('has-error');
		});
	}

	setErrorResponse(error)
	{
		this.resetErrors();
		for (let e of error.response.data.errors) {
			this.setError(e);
		}
	}

	setError(error)
	{
		if (error?.names?.length) {
			for (let name of error.names) {
				this.setNamedError(name, error.message);
			}
		} else {
			this.setUnnamedError(error.message);
		}
	}

	static getErrorMessageHtml(message)
	{
		return `<p class="b-errors__error">${message}</p>`;
	}

	setNamedError(name, message)
	{
		const errorMessageElement = this.el.querySelector(`.b-errors[data-name="${name}"]`);
		if (errorMessageElement) {
			errorMessageElement.innerHTML += MForm.getErrorMessageHtml(message);
			errorMessageElement.removeAttribute('hidden');
		} else {
			this.setUnnamedError(message);
		}

		const errorInputElement = this.el.querySelector(`[name="${name}"]`);
		if (errorInputElement) {
			errorInputElement.classList.add('has-error');
		}
	}

	setUnnamedError(message)
	{
		const errorMessageElement = this.getErrorsElement();
		if (errorMessageElement) {
			errorMessageElement.innerHTML += MForm.getErrorMessageHtml(message);
			errorMessageElement.removeAttribute('hidden');
		}
	}

	disable()
	{
		this.el.querySelectorAll('input, textarea, select, button').forEach(el => {
			el.setAttribute('disabled', true);
		});
	}

	enable()
	{
		this.el.querySelectorAll('input, textarea, select, button').forEach(el => {
			el.removeAttribute('disabled');
		});
	}

	reset()
	{
		this.el.querySelectorAll('input, textarea, select, button').forEach(el => {
			el.value = null;
		});
	}
}
